module.exports = __webpack_public_path__ + "static/media/ringtone.63415f6f.mp3";